module.exports = __webpack_public_path__ + "static/media/icon-nav-ingredients.166b8ab1.svg";